import React from "react";
import styled from "styled-components";
import favouriteAzkarData from "./FavouriteAzkarData";
import { Link } from "react-router-dom";
import { Button } from "../../../Button/Button";
import Slider from "../../../Slider/Slider";

const Container = styled.div`
  padding-top: 30px;
`;
const Title = styled.h2`
  font-weight: normal;
  color: var(--sec-color);
  margin-bottom: 10px;
`;

const ItemLink = styled(Link)`
  margin-right: 5px;
  margin-left: 10px;
`;

function FavouriteAzkar() {
  return (
    <Container>
      <Title>{favouriteAzkarData.title}</Title>
      <Slider>
        {favouriteAzkarData.List.map((item, index) => (
          <ItemLink to={item.path} key={item.id}>
            <Button btnStyle="btn--hovered">{item.name}</Button>
          </ItemLink>
        ))}
      </Slider>
    </Container>
  );
}

export default FavouriteAzkar;
